var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66675 1.5C8.94289 1.5 9.16675 1.72386 9.16675 2V9.79289L11.3132 7.64645C11.5085 7.45118 11.825 7.45118 12.0203 7.64645C12.2156 7.84171 12.2156 8.15829 12.0203 8.35355L9.0203 11.3536C8.82504 11.5488 8.50846 11.5488 8.31319 11.3536L5.31319 8.35355C5.11793 8.15829 5.11793 7.84171 5.31319 7.64645C5.50846 7.45118 5.82504 7.45118 6.0203 7.64645L8.16675 9.79289V2C8.16675 1.72386 8.39061 1.5 8.66675 1.5ZM2.66675 10.5C2.94289 10.5 3.16675 10.7239 3.16675 11V12.5C3.16675 13.0523 3.61446 13.5 4.16675 13.5H13.1667C13.719 13.5 14.1667 13.0523 14.1667 12.5V11C14.1667 10.7239 14.3906 10.5 14.6667 10.5C14.9429 10.5 15.1667 10.7239 15.1667 11V12.5C15.1667 13.6046 14.2713 14.5 13.1667 14.5H4.16675C3.06218 14.5 2.16675 13.6046 2.16675 12.5V11C2.16675 10.7239 2.39061 10.5 2.66675 10.5Z",
    fill: "#0F172A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.d202601310d245a84da4143b3530b9d4.svg";
export { ForwardRef as ReactComponent };